<template>
  <div>
    <el-dialog
      :visible.sync="isShown"
      :modal-append-to-body="false"
      title="ダッシュボード設定">
      <div>
        <el-form label-width="300px" :model="form">
          <template v-for="gadget in gadgets">
            <el-form-item :label="gadget.label">
              <el-tooltip :content="gadget.helpText" placement="right">
                <el-switch
                  active-text="表示"
                  inactive-text="非表示"
                  v-model="form[gadget.name]">
                </el-switch>
              </el-tooltip>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="update">更新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'DashboardSettingDialog',
  data () {
    const gadgets = [{
      name: 'SalesCountGadget',
      label: '売上',
      helpText: '売上の目標値と達成率を表示します',
    }, {
      name: 'PersonCountGadget',
      label: '客数',
      helpText: '客数の目標値と達成率を表示します',
    }, {
      name: 'SalesPersonCountGadget',
      label: '客単価',
      helpText: '客単価の目標値と達成率を表示します',
    }, {
      name: 'CategorySalesPieChartGadget',
      label: 'カテゴリー別売上',
      helpText: 'カテゴリー別売上の円グラフを表示します',
    }, {
      name: 'CategoryCountPieChartGadget',
      label: 'カテゴリー別出数',
      helpText: 'カテゴリー別出数の円グラフを表示します',
    }, {
      name: 'TimeSalesBarChartGadget',
      label: '時間帯別売上',
      helpText: '時間帯別売上の棒グラフを表示します',
    }, {
      name: 'TimePersonBarChartGadget',
      label: '時間帯別客数',
      helpText: '時間帯別客数の棒グラフを表示します',
    }]
    if (this.isGroupMode) {
      gadgets.push({
        name: 'ShopSalesDayGadget',
        label: '店舗別日報一覧',
        helpText: '店舗別の売上と予算を表示します',
      })
    }
    let form = {}
    gadgets.forEach(x => {
      form[x.name] = false
    })
    return {
      isShown: false,
      gadgets,
      form,
    }
  },
  methods: {
    show (selected) {
      selected.forEach(x => {
        this.form[x] = true
      })
      this.isShown = true
    },
    hide () {
      this.isShown = false
    },
    update () {
      let selected = []
      Object.keys(this.form).forEach(k => {
        if (this.form[k]) {
          selected.push(k)
        }
      })
      this.$emit('updated', selected)
      this.hide()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardSettingDialog.vue